module.exports = __webpack_public_path__ + "static/media/compare_bg.4a8607e1.png";